import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { style: {"text-align":"center","font-family":"Roboto Slab,sans-serif","margin-top":"1em"} }, "Oh! Hier ist wohl die Kette abgesprungen....!", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.image404,
        class: "img-fluid",
        alt: "404 Image",
        style: {"margin-top":"2.5em","border-radius":"25px"}
      }, null, 8 /* PROPS */, _hoisted_3),
      _hoisted_4
    ])
  ]))
}